/* Arquebus theme motion + store behaviour */
(function () {
  'use strict';
  var A = window.Arq || {};
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) root.classList.add('reduced');
  var lite = reduced || !!A.designMode;           // no pinning / smooth scroll in the theme editor
  var hasG = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  var hasT = typeof THREE !== 'undefined';
  var isSmall = function () { return window.innerWidth < 820; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var S = { scroll: 0, mx: 0, my: 0, bean: 0 };
  var lenis = null;

  /* ---------- toast ---------- */
  var tt;
  function toast(m) {
    var t = $('#toast'); if (!t) return;
    t.textContent = m; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  /* ---------- cart ---------- */
  function refreshCount() {
    fetch((A.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { var el = $('#cartCount'); if (el) el.textContent = c.item_count; })
      .catch(function () {});
  }
  function bindAddForms(scope) {
    $$('form.add-form', scope).forEach(function (f) {
      if (f.dataset.bound) return; f.dataset.bound = '1';
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = f.querySelector('button[type=submit]');
        if (btn) btn.disabled = true;
        fetch((A.cartAddUrl || '/cart/add') + '.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
            toast((f.dataset.name || 'Item') + ' ' + (A.addedText || 'added to your bag'));
            refreshCount();
          })
          .catch(function (err) { toast(err.message || A.errorText || 'Could not add that. Try again.'); })
          .then(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ---------- option buttons (variants, grinds, amounts) ---------- */
  function bindOptionGroups(scope) {
    $$('.grind, .amounts', scope).forEach(function (g) {
      if (g.dataset.bound) return; g.dataset.bound = '1';
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        $$('button', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (b.dataset.variant) {
          var form = g.closest('form'); var input = form && form.querySelector('input[name=id]');
          if (input) input.value = b.dataset.variant;
          if (b.dataset.price) {
            var card = g.closest('.prod, .pdp-info');
            var pr = card && (card.querySelector('.pr') || card.querySelector('#pdpPrice'));
            if (pr) pr.textContent = b.dataset.price;
          }
        }
      });
    });
  }

  /* ---------- tabs ---------- */
  function bindTabs(scope) {
    var tabs = $$('[role=tab]', scope);
    tabs.forEach(function (t) {
      if (t.dataset.bound) return; t.dataset.bound = '1';
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', String(on));
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
      });
    });
  }

  /* ---------- tile wall ---------- */
  function buildTiles(scope) {
    var wall = $('#tilewall', scope);
    if (!wall || wall.children.length) return wall;
    for (var r = 0; r < 4; r++) for (var c = 0; c < 6; c++) {
      var d = document.createElement('div');
      d.style.backgroundPosition = (c / 5 * 100) + '% ' + (r / 3 * 100) + '%';
      wall.appendChild(d);
    }
    return wall;
  }

  /* ---------- member card tilt ---------- */
  function bindCard(scope) {
    var card = $('#member', scope), stage = $('#stage', scope);
    if (!card || !stage || reduced || stage.dataset.bound) return; stage.dataset.bound = '1';
    function tilt(x, y) {
      card.style.transform = 'rotateY(' + (x * 18) + 'deg) rotateX(' + (-y * 14) + 'deg)';
      card.style.setProperty('--mx', (50 + x * 60) + '%'); card.style.setProperty('--my', (50 + y * 60) + '%');
    }
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = card.getBoundingClientRect(); tilt((e.clientX - r.left) / r.width - .5, (e.clientY - r.top) / r.height - .5);
    });
    stage.addEventListener('pointerleave', function () { tilt(0, 0); });
    if (window.matchMedia('(pointer:coarse)').matches) {
      var a = 0; (function idle() { a += .012; tilt(Math.sin(a) * .35, Math.cos(a * .8) * .25); requestAnimationFrame(idle); })();
    }
  }

  /* ---------- open now ---------- */
  function openNow(scope) {
    var el = $('#openNow', scope); if (!el) return;
    var rows = $$('.hours tr[data-day]', scope); if (!rows.length) return;
    try {
      var tz = el.dataset.tz || 'America/New_York';
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
      var day = get('weekday'), mins = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
      var toM = function (s) { var m = /^(\d{1,2}):(\d{2})$/.exec((s || '').trim()); return m ? (+m[1]) * 60 + (+m[2]) : null; };
      var row = rows.find(function (r) { return r.dataset.day === day; });
      if (!row) return;
      row.classList.add('today');
      var o = toM(row.dataset.open), c = toM(row.dataset.close);
      var open = row.dataset.closed !== 'true' && o !== null && c !== null && mins >= o && mins < c;
      el.textContent = open ? 'Open now' : 'Closed now';
      el.classList.toggle('is-open', open);
      el.hidden = false;
    } catch (e) { /* leave hidden */ }
  }

  function initUI(scope) {
    bindAddForms(scope); bindOptionGroups(scope); bindTabs(scope); buildTiles(scope); bindCard(scope); openNow(scope);
  }

  /* ---------- cursor + nav ---------- */
  var cur = $('.cursor');
  if (cur && !reduced && window.matchMedia('(pointer:fine)').matches) {
    var cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy;
    addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; cur.classList.add('live'); });
    (function loop() { cx += (tx - cx) * .18; cy += (ty - cy) * .18; cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)'; requestAnimationFrame(loop); })();
    document.addEventListener('pointerover', function (e) {
      cur.classList.toggle('big', !!e.target.closest('a,button,.prod .ph,.member'));
    });
  }
  var nav = $('.nav');
  var onNav = function () { if (nav) nav.classList.toggle('solid', scrollY > 40 || !A.isHome); };
  addEventListener('scroll', onNav, { passive: true }); onNav();
  addEventListener('pointermove', function (e) { S.mx = e.clientX / innerWidth - .5; S.my = e.clientY / innerHeight - .5; }, { passive: true });

  /* ---------- hero falls shader ---------- */
  function initFalls(cv) {
    if (!hasT || !cv || cv.dataset.gl) return; cv.dataset.gl = '1';
    try {
      var visible = true;
      var r = new THREE.WebGLRenderer({ canvas: cv, antialias: false, powerPreference: 'high-performance' });
      var dpr = Math.min(devicePixelRatio, isSmall() ? 1.25 : 1.5); r.setPixelRatio(dpr);
      var sc = new THREE.Scene(), cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
      var U = { uT: { value: 0 }, uRes: { value: new THREE.Vector2() }, uM: { value: new THREE.Vector2() }, uS: { value: 0 } };
      var mat = new THREE.ShaderMaterial({
        uniforms: U,
        vertexShader: 'void main(){gl_Position=vec4(position,1.0);}',
        fragmentShader: [
          'precision highp float;',
          'uniform float uT;uniform vec2 uRes;uniform vec2 uM;uniform float uS;',
          'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
          'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1.,0.)),f.x),mix(h(i+vec2(0.,1.)),h(i+vec2(1.,1.)),f.x),f.y);}',
          'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}',
          'void main(){',
          ' vec2 uv=gl_FragCoord.xy/uRes;float asp=uRes.x/uRes.y;',
          ' vec2 p=vec2((uv.x-.62)*asp,uv.y)+uM*vec2(.04,.02);',
          ' p.y+=uS*.18; float y=uv.y+uS*.18;',
          ' float brink=.68+.02*sin(p.x*2.2+1.3)+.01*sin(p.x*7.);',
          ' vec3 ink=vec3(.055,.047,.039),cream=vec3(.937,.902,.839),gold=vec3(.84,.68,.27);',
          ' float below=smoothstep(brink+.004,brink-.04,y);',
          ' float cx=smoothstep(-1.15,-.55,p.x)*smoothstep(1.25,.7,p.x);',
          ' float warp=fbm(vec2(p.x*2.2,y*.7+uT*.22));',
          ' float field=p.x*58.+warp*7.;',
          ' float ridge=pow(1.-abs(fract(field)-.5)*2.,6.);',
          ' float fall=fbm(vec2(p.x*5.,y*2.0+uT*1.05));',
          ' float sheen=smoothstep(.25,.8,fall)*(.55+.45*smoothstep(brink-.5,brink,y));',
          ' float water=ridge*sheen*below*cx;',
          ' float lip=exp(-pow((y-brink)*80.,2.))*cx;',
          ' float above=smoothstep(brink-.004,brink+.02,y);',
          ' float rf=y*150.+fbm(vec2(p.x*1.4-uT*.14,y*4.))*6.;',
          ' float river=pow(1.-abs(fract(rf)-.5)*2.,14.)*above*.32*smoothstep(1.02,.8,y);',
          ' float m=fbm(vec2(p.x*1.5+uT*.03,y*2.1-uT*.13));',
          ' float mist=smoothstep(.5,.0,y)*m*1.15+smoothstep(.28,.0,y)*.18;',
          ' vec3 col=ink; col+=cream*water*1.05; col+=cream*lip*.55; col+=cream*river;',
          ' col+=mix(cream,gold,.3)*mist*.34;',
          ' col+=gold*pow(water,2.)*.28*(sin(uT*.6+p.x*3.)*.5+.5);',
          ' float vig=smoothstep(1.35,.2,length((uv-vec2(.6,.5))*vec2(asp*.7,1.1)));',
          ' col*=mix(.3,1.,vig); col*=1.-uS*.7;',
          ' col+=(h(gl_FragCoord.xy+fract(uT))-.5)*.035;',
          ' gl_FragColor=vec4(col,1.);',
          '}'
        ].join('\n')
      });
      sc.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), mat));
      var size = function () { var w = cv.clientWidth, hh = cv.clientHeight; r.setSize(w, hh, false); U.uRes.value.set(w * dpr, hh * dpr); };
      size(); addEventListener('resize', size);
      var clock = new THREE.Clock(), sm = new THREE.Vector2();
      var draw = function () {
        if (visible) {
          U.uT.value = reduced ? 4.0 : clock.getElapsedTime();
          sm.x += (S.mx - sm.x) * .05; sm.y += (S.my - sm.y) * .05; U.uM.value.copy(sm); U.uS.value = S.scroll;
          r.render(sc, cam);
        }
        if (!reduced) requestAnimationFrame(draw);
      };
      draw();
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { rootMargin: '100px' }).observe(cv);
    } catch (e) { console.warn(e); }
  }

  /* ---------- 3D bean ---------- */
  function initBean(cv) {
    if (!hasT || !cv || cv.dataset.gl) return; cv.dataset.gl = '1';
    try {
      var visible = false;
      var r = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
      r.setPixelRatio(Math.min(devicePixelRatio, isSmall() ? 1.5 : 2));
      var sc = new THREE.Scene();
      var cam = new THREE.PerspectiveCamera(32, 1, .1, 100); cam.position.set(0, 0, 7.5);
      var g = new THREE.SphereGeometry(1, 160, 120);
      var pos = g.attributes.position, v = new THREE.Vector3();
      for (var i = 0; i < pos.count; i++) {
        v.fromBufferAttribute(pos, i);
        var x = v.x, y = v.y, z = v.z;
        if (z > 0) z *= 0.42;
        var c = 0.10 * Math.sin(y * 2.4), d = x - c;
        var groove = Math.exp(-(d * d) / 0.009) * Math.min(1, Math.max(0, z) / 0.25);
        z -= groove * 0.3;
        pos.setXYZ(i, x * 0.82, y * 1.1, z * 0.8);
      }
      g.computeVertexNormals();
      var mat = new THREE.MeshPhysicalMaterial({ color: 0x8e1d1d, roughness: .42, metalness: 0, clearcoat: .6, clearcoatRoughness: .35 });
      var bean = new THREE.Mesh(g, mat);
      var grp = new THREE.Group(); grp.add(bean); sc.add(grp);
      var N = isSmall() ? 260 : 520, pg = new THREE.BufferGeometry(), pa = new Float32Array(N * 3);
      for (var k = 0; k < N; k++) {
        var a = Math.random() * Math.PI * 2, rad = 1.9 + Math.random() * 1.6;
        pa[k * 3] = Math.cos(a) * rad; pa[k * 3 + 1] = (Math.random() - .5) * 2.4; pa[k * 3 + 2] = Math.sin(a) * rad;
      }
      pg.setAttribute('position', new THREE.BufferAttribute(pa, 3));
      var dust = new THREE.Points(pg, new THREE.PointsMaterial({ color: 0xd6ad46, size: .022, transparent: true, opacity: .7, depthWrite: false }));
      sc.add(dust);
      sc.add(new THREE.AmbientLight(0xfff1dc, .18));
      var key = new THREE.DirectionalLight(0xfff0d8, .95); key.position.set(3, 4, 5); sc.add(key);
      var rim = new THREE.PointLight(0xd6ad46, 3.2, 20); rim.position.set(-3.5, 1.5, -2.5); sc.add(rim);
      var rim2 = new THREE.PointLight(0xffd9a0, 1.4, 20); rim2.position.set(3, -2, -3); sc.add(rim2);
      var stops = [0x9b1f1f, 0x8d9a5e, 0xb8874a, 0x5a3219, 0x2a170c].map(function (h) { return new THREE.Color(h); });
      var tmp = new THREE.Color();
      var size = function () {
        var w = cv.clientWidth, hh = cv.clientHeight; r.setSize(w, hh, false); cam.aspect = w / hh; cam.updateProjectionMatrix();
        grp.position.set(isSmall() ? 0 : 1.25, isSmall() ? .55 : .05, 0); grp.scale.setScalar(isSmall() ? .72 : 1);
      };
      size(); addEventListener('resize', size);
      var clock = new THREE.Clock(), sp = 0;
      var draw = function () {
        if (visible || reduced) {
          var t = clock.getElapsedTime();
          sp += (S.bean - sp) * .08;
          var f = sp * (stops.length - 1), j = Math.min(Math.floor(f), stops.length - 2);
          tmp.copy(stops[j]).lerp(stops[j + 1], f - j); mat.color.copy(tmp);
          mat.roughness = .42 + sp * .25; mat.clearcoat = .6 - sp * .4;
          bean.rotation.y = Math.sin(t * .35) * .9 + sp * Math.PI * 2 - .3;
          bean.rotation.x = Math.sin(t * .4) * .2 + .25; bean.rotation.z = .5 + sp * .6;
          grp.position.y = (isSmall() ? .55 : .05) + Math.sin(t * .8) * .06;
          dust.rotation.y = t * .04 + sp * 1.5;
          var pulse = sp > .45 && sp < .62 ? 1 : 0; rim.intensity = 3.2 + pulse * Math.abs(Math.sin(t * 9)) * 2.5;
          r.render(sc, cam);
        }
        if (!reduced) requestAnimationFrame(draw);
      };
      draw();
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { rootMargin: '200px' }).observe(cv);
      else visible = true;
    } catch (e) { console.warn(e); }
  }

  /* ---------- loader ---------- */
  function hideLoader() { var ld = $('.loader'); if (ld) ld.style.display = 'none'; }
  function intro() {
    var ld = $('.loader');
    var seen = false;
    try { seen = sessionStorage.getItem('arq-intro') === '1'; sessionStorage.setItem('arq-intro', '1'); } catch (e) {}
    if (!ld || lite || !hasG || seen) { hideLoader(); return; }
    var o = { v: 0 }, lc = $('#lc');
    gsap.timeline()
      .to('.loader .ls', { clipPath: 'circle(75% at 50% 50%)', duration: 1.3, ease: 'power2.inOut' }, 0)
      .to(o, { v: 100, duration: 1.3, ease: 'power2.inOut', onUpdate: function () { if (lc) lc.textContent = String(Math.round(o.v)).padStart(3, '0'); } }, 0)
      .to(ld, { yPercent: -100, duration: .9, ease: 'expo.inOut' }, '+=.15')
      .from('.hero h1 .ln > span', { yPercent: 110, duration: 1.1, ease: 'expo.out', stagger: .1 }, '-=.45')
      .from('.hero .eyebrow, .hero .lede, .hero .ctas', { y: 24, opacity: 0, duration: .9, ease: 'power3.out', stagger: .08 }, '-=.8')
      .from('.seal-wrap', { scale: .8, opacity: 0, rotate: -20, duration: 1.4, ease: 'expo.out' }, '-=1')
      .set(ld, { display: 'none' });
  }

  /* ---------- scroll choreography (homepage) ---------- */
  function splitWords(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
      if (ch.nodeType === 3) {
        var frag = document.createDocumentFragment();
        ch.textContent.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
          var s = document.createElement('span'); s.className = 'w'; s.textContent = w; frag.appendChild(s);
        });
        ch.parentNode.replaceChild(frag, ch);
      } else if (ch.nodeType === 1) splitWords(ch);
    });
  }

  function choreograph() {
    gsap.registerPlugin(ScrollTrigger);

    if (typeof Lenis !== 'undefined') {
      lenis = new Lenis({ duration: 1.2, smoothWheel: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); }); gsap.ticker.lagSmoothing(0);
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]'); if (!a || !lenis) return;
      var href = a.getAttribute('href'); var m = /^\/?#([\w-]+)$/.exec(href); if (!m) return;
      var el = document.getElementById(m[1]); if (!el) return;
      e.preventDefault(); lenis.scrollTo(el, { duration: 1.6 });
    });

    if ($('.hero')) {
      ScrollTrigger.create({ trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true, onUpdate: function (s) { S.scroll = s.progress; } });
      gsap.to('.hero .inner > div:first-child', { yPercent: -18, opacity: .2, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.seal-wrap .s', { rotate: 25, scale: 1.15, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
    }

    var mq = $('.marquee .track');
    if (mq) {
      var skew = 0;
      ScrollTrigger.create({ onUpdate: function (s) { var v = gsap.utils.clamp(-12, 12, s.getVelocity() / 250); if (Math.abs(v) > Math.abs(skew)) skew = v; } });
      gsap.ticker.add(function () { skew *= .9; mq.style.transform = 'skewX(' + (-skew) + 'deg)'; });
    }

    var st = $('#storyText');
    if (st) {
      splitWords(st);
      gsap.fromTo('#storyText .w', { opacity: .13 }, { opacity: 1, stagger: .06, ease: 'none', scrollTrigger: { trigger: '#story', start: 'top top', end: '+=140%', pin: true, scrub: .6 } });
      $$('.stat b').forEach(function (b) {
        var n = +b.dataset.count || 0, o = { v: 0 };
        gsap.to(o, { v: n, duration: 1.8, ease: 'power2.out', scrollTrigger: { trigger: '#story', start: 'top 60%', once: true }, onUpdate: function () { b.textContent = Math.round(o.v); } });
      });
    }

    var track = $('#track');
    if (track) {
      var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
      var meter = $('#meter');
      var roastTween = gsap.to(track, {
        x: function () { return -dist(); }, ease: 'none',
        scrollTrigger: {
          trigger: '#roast', start: 'top top', end: function () { return '+=' + Math.max(window.innerHeight, dist() * 1.1); },
          pin: true, scrub: .8, invalidateOnRefresh: true, anticipatePin: 1,
          onUpdate: function (s) { S.bean = s.progress; if (meter) meter.style.transform = 'scaleX(' + s.progress + ')'; }
        }
      });
      $$('.step .card').forEach(function (c) {
        gsap.from(c.children, { y: 40, opacity: 0, stagger: .08, duration: .8, ease: 'power3.out', scrollTrigger: { trigger: c, containerAnimation: roastTween, start: 'left 80%' } });
      });
    }

    $$('.sec-head h2').forEach(function (h) { gsap.from(h, { yPercent: 40, opacity: 0, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: h, start: 'top 88%' } }); });
    $$('.menu-col').forEach(function (col) { gsap.from(col.querySelectorAll('.item'), { y: 30, opacity: 0, stagger: .07, duration: .8, ease: 'power3.out', scrollTrigger: { trigger: col, start: 'top 80%' } }); });

    var cells = $$('#tilewall div');
    if (cells.length) {
      gsap.from(cells, {
        x: function () { return gsap.utils.random(-300, 300); }, y: function () { return gsap.utils.random(-220, 220); },
        rotate: function () { return gsap.utils.random(-90, 90); }, scale: .4, opacity: 0, ease: 'power3.out',
        stagger: { each: .02, from: 'random' }, scrollTrigger: { trigger: '#tilewall', start: 'top 95%', end: 'center 55%', scrub: 1 }
      });
    }
    if ($('.products')) $$('.shop .prod').forEach(function (p, i) { gsap.from(p, { y: 80, opacity: 0, duration: 1.1, delay: i * .08, ease: 'expo.out', scrollTrigger: { trigger: p.parentNode, start: 'top 85%' } }); });
    if ($('#member')) gsap.from('#member', { rotateY: -70, rotateX: 20, y: 80, opacity: 0, duration: 1.6, ease: 'expo.out', scrollTrigger: { trigger: '#cards', start: 'top 70%' } });
    if ($('.visit h2')) gsap.from('.visit h2', { yPercent: 30, opacity: 0, duration: 1.3, ease: 'expo.out', scrollTrigger: { trigger: '.visit', start: 'top 75%' } });
    if ($('.foot .big')) gsap.fromTo('.foot .big', { letterSpacing: '.4em' }, { letterSpacing: '.04em', ease: 'none', scrollTrigger: { trigger: '.foot', start: 'top bottom', end: 'bottom bottom', scrub: true } });

    var jumpToHash = function () {
      var id = (location.hash || '').slice(1); if (!/^[\w-]+$/.test(id)) return;
      var el = document.getElementById(id); if (!el) return;
      if (lenis) lenis.scrollTo(el, { immediate: true }); else el.scrollIntoView();
    };
    var refresh = function () { ScrollTrigger.refresh(); jumpToHash(); };
    if (document.readyState === 'complete') setTimeout(refresh, 50); else addEventListener('load', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }

  /* ---------- boot ---------- */
  initUI(document);
  refreshCount();
  initFalls($('#falls'));
  initBean($('#bean'));

  if (hasG && !lite && A.isHome) {
    intro();
    choreograph();
  } else {
    hideLoader();
    // simple fallback: drive the bean colour from page position
    addEventListener('scroll', function () {
      var rs = $('#roast'); if (!rs) return;
      var r = rs.getBoundingClientRect();
      S.bean = Math.min(1, Math.max(0, (innerHeight - r.top) / (r.height + innerHeight)));
    }, { passive: true });
    if (reduced) S.bean = .7;
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initUI(e.target);
    initFalls($('#falls', e.target));
    initBean($('#bean', e.target));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest('#p-loyal') ? $('#tab-loyal') : null; if (tab) tab.click();
  });
})();
